import { jwtDecode } from 'jwt-decode';

export default function checkAndRemoveExpiredToken() {
  const token = localStorage.getItem('token');

  if (token) {
    try {
      // Decode the token to get its payload
      const decodedToken = jwtDecode(token);

      // Check if the token is expired
      const currentTime = Math.floor(Date.now() / 1000);
      if (decodedToken.exp < currentTime) {
        localStorage.removeItem('token');
      }
    } catch (error) {
      localStorage.removeItem('token');
    }
  }
}
